'use client';

import { type PropsWithChildren, useEffect, useState } from 'react';

/**
 * this high order component make sure to render the children only on the client side
 * if you are seem problems, you can use this component to avoid rendering the children on the server
 */

export function RenderOnClient({ children }: PropsWithChildren) {
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);
    return isClient && <>{children}</>;
}
